export const ROUTES = {
  // New public auth routes (redesigned flow)
  REGISTER: '/register',
  LOGIN_NEW: '/login',
  // Legacy login route (kept working for emailed links / bookmarks)
  LOGIN: '/doctor/login',
  DOCTOR_DASHBOARD: '/doctor/dashboard',
  MANAGE_SESSIONS: '/doctor/sessions/manage',
  SESSION_VIEW: '/doctor/sessions/view',
  MEETING: '/doctor/meetings',
  ADMIN_DASHBOARD: '/admin/dashboard',
  AI_USAGE_DASHBOARD: '/admin/ai-usage',
  ADMIN_REGISTRATION: '/admin/registration',
  SUPER_ADMIN_DASHBOARD: '/super-admin/dashboard',
  PROFILE: '/profile',
  CLINIC_PROFILE: '/clinic/profile',
  CLINIC_ADMINISTRATION: '/clinic/administration',
  SCHEDULING: '/clinic/scheduling',
  PROTOCOLS: '/clinic/protocols',
  VERIFY_EMAIL: '/verify-email',
  FORGOT_PASSWORD: '/forgot-password',
  TEST_WORKFLOW: '/test/workflow',
  TEST_WORKFLOW_APPROVAL: '/test/workflow/approval',
  CONSULT_LANGUAGE_PREVIEW: '/dev/consult-language-preview',
  TKR_PATHWAY: '/doctor/tkr-pathway/:episodeId',
  TKR_DASHBOARD: '/doctor/tkr-dashboard',
  TKR_EPISODE: '/doctor/tkr-episode/:episodeId',
  TKR_SDM: '/doctor/tkr-pathway/:episodeId/sdm',
  VBC_DASHBOARD: '/doctor/vbc-dashboard',
} as const;
